import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'


import MainBar from '@/components/NavMain'
import NotFound from '@/components/404'
// import Profile from '@/components/dashboard/Profile'
import AdminDash from '@/components/admin/dashboard'

//App Admin:
import User from '@/components/admin/users'
import SAUser from '@/components/admin/sausers'
import Items from '@/components/admin/items'
import Orders from '@/components/admin/orders'
import Equipment from '@/components/admin/equipment'
import Accounts from '@/components/admin/account'
import AccountEdit from '@/components/admin/AccountEdit'
import Sites from '@/components/admin/sites'
import SiteEdit from '@/components/admin/SiteEdit'
import ForgotPassword from '@/components/admin/ForgotPassword'
import ResetPassword from '@/components/admin/ResetPassword'
import OrderAcknowledge from '@/components/admin/OrderAcknowledge'

//Profile:
import Profile from '@/components/admin/profile'



import store from '@/store/store'


Vue.use(Router)


// var GetMenu = (id = 0) => {
//   return (id === 0) ? demo.OrderDashBoardMenu : demo.SupportDashBoadMenu
// }

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      name: 'NotFound',
      components: {
        nav: MainBar,
        body: NotFound,
      },
      props: {
        nav: false,
        body: true
      }
    },
    {
      path: '/error',
      name: 'ErrPage',
      components: {
        nav: MainBar,
        body: NotFound,
      },
      props: {
        nav: false,
        body: true
      }
    },
    {
      path: "/forgot",
      name: 'forgot',
      components: {
        nav: MainBar,
        body: ForgotPassword
      },
    },
    {
      path: '/reset',
      components: {
        nav: MainBar,
        body: ResetPassword
      },
      props: {
        nav: false,
        body(route) {
          return { tk: route.query.tk }
        }
      },
    },
    {
      path: '/ordack',
      components: {
        nav: MainBar,
        body: OrderAcknowledge
      },
      props: {
        nav: false,
        body(route) {
          return { tk: route.query.tk }
        }
      },
    },
    {
      path: '/',
      name: 'Home',
      components: {
        nav: null,
        body: Home
      },
      meta: {
        auth: false
      }
    },
    {
      path: '/admin',
      components: {
        nav: MainBar,
        body: AdminDash
      },
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
          props(route) {
            return { returnUrl: route.params.returnUrl };
          },
          beforeEnter(to, from, next) {
            debugger;
            var str = store;
            if (!str.getters["user/isAuthenticated"]) {
              str.dispatch('user/refresh')
                .then(() => {
                  if (!str.getters["user/isAuthenticated"]) {
                    next('/')
                  } else {
                    next({ returnUrl: from.path })
                  }
                })
            } else {

              next({ returnUrl: from.path })
            }
          }
        },
        {
          name: 'order',
          path: '',
          component: Orders,
          props: (route) => {
            var ord = {};
            debugger;
            ord = route.params.ord;

            if (!ord) {
              return {};
            }


            var str = store;

            //are items loaded?
            if (str.getters["sysItems/items"].length === 0) {
              return str.dispatch("sysItems/getItems")
                .then(() => {
                  //existing order will need items loaded:
                  if (ord.id && ord.items.length === 0) {
                    var str = store;

                    return str.dispatch('orders/getOrder', ord.id)
                      .then(order => {
                        order.items.forEach(o => ord.items.push(o));
                        return { ord };
                      });
                  } else {

                    return { ord };
                  }
                })
            } else {

              //existing order will need items loaded:
              if (ord.id && ord.items.length === 0) {
                var str = store;

                return str.dispatch('orders/getOrder', ord.id)
                  .then(order => {
                    order.items.forEach(o => ord.items.push(o));
                    return { ord };
                  });
              } else {

                return { ord };
              }
            }
          },
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          name: '',
          path: 'order',
          component: Orders,
          props: true,
          beforeEnter(to, from, next) {
            var id;
            id = to.query.id;

            if (!id) {
              return {};
            }

            //Convert to int:
            id = parseInt(id);


            var str = store;

            //are items loaded?
            if (str.getters["sysItems/items"].length === 0) {
              str.dispatch("sysItems/getItems")
                .then(() => {
                  //Get order:
                  str.dispatch('orders/getOrder', id)
                    .then(order => {
                      debugger;
                      to.params.ord = order;
                      next();
                      //return { ord: order };
                    });
                })
            } else {

              //existing order will need items loaded:         
              var str = store;

              str.dispatch('orders/getOrder', id)
                .then(order => {
                  debugger;
                  to.params.ord = order
                  next();
                  // return { ord: order };
                });
            }
          },
          // props: (route) => {
          //   var id;
          //   id = route.query.id;
          //   debugger;
          //   if (!id) {
          //     return {};
          //   }

          //   //Convert to int:
          //   id = parseInt(id);

          //   var str = store;

          //   //are items loaded?
          //   if (str.getters["sysItems/items"].length === 0) {
          //     str.dispatch("sysItems/getItems")
          //       .then(() => {
          //         //Get order:
          //         str.dispatch('orders/getOrder', id)
          //           .then(order => {
          //             debugger;
          //             return { ord: order };
          //           });
          //       })
          //   } else {

          //     //existing order will need items loaded:         
          //     var str = store;

          //     str.dispatch('orders/getOrder', id)
          //       .then(order => {
          //         debugger;
          //         return { ord: order };
          //       });
          //   }
          // },
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          path: 'user',
          component: User,
          beforeEnter(to, from, next) {
            var str = store;

            if (str.getters['accounts/accounts'].length === 0) {
              str.dispatch('accounts/getAccounts')
                .then(() => {
                  str.dispatch('sysUsers/refreshUsersAsync')
                    .then(() => next())
                })
            } else {
              next();
            }
          },
          props(route) {
            return { id: route.query.id }
          },
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          name: 'sauser',
          path: 'sa',
          component: SAUser,
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          name: 'accounts',
          path: 'accounts',
          components: {
            default: Accounts,
            body: Sites,
            editor: Sites,
          },
          children: [
            {
              path: '/account/:account/',
              component: AccountEdit,
              meta: {
                auth: true,
                type: 'sa',
              },
              // props(route) {
              //   debugger;
              //   var st = store;
              //   var site_id = route.params.id;
              //   return st.dispatch('accounts/accountSearch', site_id)
              //     .then(rsp => {
              //       debugger;
              //     })
              // },
              beforeEnter(to, from, next) {
                var str = store;
                if (str.getters["accounts/currentAccount"] === null) {
                  str.dispatch('accounts/getAccounts')
                    .then(() => next("/admin/accounts"))
                  // next('/admin/accounts');
                } else {
                  debugger;
                  if (str.getters["sysItems/items"].length === 0) {
                    return str.dispatch("sysItems/getItems")
                      .then(() => next())
                  } else {

                    next();
                  }
                }
              }
            },
            {
              name: 'account',
              path: '/account/:account/:site',
              component: SiteEdit,
              meta: {
                auth: true,
                type: 'sa',
              },
              beforeEnter(to, from, next) {
                var str = store;
                if (str.getters["accounts/currentAccount"] === null) {
                  next("/admin/accounts");
                } else {
                  next();
                }
              },
              props(route) {
                debugger;
                var str = store;

                var site_id = route.params.site;
                var account = str.getters["accounts/currentAccount"];

                if (!account) {
                  console.error('No Account found!');
                }

                var site = null;

                if (site_id > 0) {
                  site = account.sites.find(s => s.id === site_id);
                } else {
                  site = str.getters["accounts/currentSite"];
                }


                debugger;
                if (str.getters["sysItems/items"].length === 0) {
                  return str.dispatch("sysItems/getItems")
                    .then(() => str.dispatch("accounts/getSaUsers"))
                    .then(() => ({
                      site: site,
                      account: account,
                      allowReturn: true
                    }));
                }
                return {
                  site: site,
                  account: account,
                  allowReturn: true
                }

              },
              // beforeEnter(to, from, next) {
              //   var str = store;
              //   if (str.getters["accounts/currentAccount"] === null) {
              //     next('/admin/accounts');
              //   } else {
              //     next();
              //   }
              // },
            }
            // {
            //   name: 'edit',
            //   path: 'edit',
            //   component: SiteEdit,
            //   props: true,
            //   meta: {
            //     auth: true,
            //     type: 'sa',
            //   },
            //   beforeEnter(to, from, next) {
            //     var str = store;
            //     if (str.getters["accounts/currentSite"] === null) {
            //       if (str.getters["accounts/currentAccount"] == null) {
            //         next('/admin/accounts')
            //       } else {
            //         next('/admin/accounts/sites')
            //       }
            //       return
            //     } else {
            //       debugger;
            //       str.dispatch('sysEquipment/getModels').then(() => {
            //         if (!str.getters["sysItems/items"] || str.getters["sysItems/items"].length === 0) {
            //           str.dispatch("sysItems/getItems").then(() => str.dispatch("accounts/getSaUsers").then(() => next()));

            //         } else {

            //           str.dispatch("accounts/getSaUsers").then(() => next())
            //         }
            //       });
            //     }
            //   }
            // }
          ],
          beforeEnter(to, from, next) {
            debugger;

            var str = store;

            if (str.getters["accounts/accounts"].length == 0) {
              var str = store;
              return str
                .dispatch("accounts/getAccounts")
                .then(() => str.dispatch("accounts/getSaUsers"))
                .then(() => {
                  if (str.getters["accounts/currentAccount"] !== null) {
                    return str.dispatch('accounts/currentAccount')
                      .then(() => next());
                  } else {
                    next();
                  }
                });
            } else {
              str.dispatch("accounts/getSaUsers")
                .then(() => next());
            }



          },
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          name: 'items',
          path: 'items',
          component: Items,
          meta: {
            auth: true,
            type: 'sa',
          }
        },
        {
          name: 'equipment',
          path: 'equipment',
          component: Equipment,
          meta: {
            auth: true,
            type: 'sa',
          }
        }
      ],
      meta: {
        auth: true,
        radar: true
      }
      // beforeEnter(to, from, next) {
      //   debugger;
      //   var str = store;

      //   if (str.getters["accounts/accounts"].length == 0) {
      //     var str = store;

      //     return str
      //       .dispatch("accounts/getAccounts")
      //       .then(() => str.dispatch("accounts/getSaUsers"))
      //       .then(() => next());
      //   } else {
      //     debugger;

      //     return str.dispatch("accounts/getSaUsers")
      //       .then(() => next());
      //   }
      // }
    }
  ],
})


router.beforeEach((to, from, next) => {
  var st = store;
  var dev = false;

  if (dev) {
    next()
    return;
  }
  if (st.getters["user/isAuthenticated"] && to.path === '/') {
    next('/admin')
    return
  }
  // debugger
  if (to.meta.auth) {
    st.dispatch('user/refresh').then(() => {
      // debugger
      var authy = st.getters["user/isAuthenticated"]
      if (to.meta.auth) {

        if (!authy) {
          next('/')
        } else {
          next()
        }

      } else {
        if (to.path === '/' && authy) {
          // debugger
          next('/admin')
        } else if (to.meta.radar) {
          // debugger
          var allowed = st.dispatch("user/isAllowed")
            .then(rsp => {
              // debugger
              if (rsp) {
                next()
              } else {
                next(to.meta.returnUrl)
              }
            })
        } else {
          next()
        }
      }


    })
      .catch(err => {
        next('/')
      })
  } else {
    next();
  }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/router.js